import axios from 'axios';
import { convertKeysToCamelCase, convertKeysToSnakeCase } from 'utils/helpers';
import config from 'config';

const identityFetcher = axios.create({
  baseURL: `${config.apiBaseUrl}/v1.0/identity`,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

identityFetcher.interceptors.request.use(
  async (config) => {
    if (config?.data) {
      config.data = convertKeysToSnakeCase(config.data);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

identityFetcher.interceptors.response.use(
  (response) => convertKeysToCamelCase(response?.data),
  (error) => {
    return Promise.reject({
      message: error.response?.data?.invalid_params?.non_field_errors?.[0] || error.response?.data?.invalid_params?.code?.[0],
    });
  }
);

export default identityFetcher;
